import { Draggable } from 'react-beautiful-dnd';
import React from 'react';
import PollEntity from '../../../store/polls-store/poll-entity';
import Poll from '../polls-list-container/polls-list-item';
import { useStore } from './../../../store/store-provider';
import { observer } from 'mobx-react';
import { MIDDLE_SIZE_BREAKPOINT } from '../../../constans/responsive-break-points';

interface IProps {
  poll: PollEntity;
  index: number;
  selectPoll: (pollId: string) => void;
}

const DraggablePollWrapper: React.FC<IProps> = ({
  poll,
  index,
  selectPoll,
}): JSX.Element => {
  const { pollsStore, podiumInfoStore } = useStore();
  const pollId = poll.getId();
  const isSelected = pollId === pollsStore.selectedPollId;
  const isEllipsisMenuOpened = pollsStore.isEllipsisMenuOpened;
  const isMobile = podiumInfoStore.isResolutionBreakPointActive(MIDDLE_SIZE_BREAKPOINT);

  const handleSelectPoll = (): void => {
    selectPoll(pollId);
  };

  return (
    <>
      <Draggable
        key={pollId}
        draggableId={pollId}
        index={index}
      >
        {(provided) => (
          <div onClick={handleSelectPoll} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <Poll
              poll={poll}
              isSelected={isSelected}
              isEllipsisMenuOpened={isEllipsisMenuOpened}
              setShouldShowEllipsisMenu={pollsStore.setShouldShowEllipsisMenu}
              toggleManagePollModal={pollsStore.toggleManagePollModal}
              setShouldShowDeleteModal={pollsStore.setShouldShowDeleteModal}
              setShouldShowResetModal={pollsStore.setShouldShowResetModal}
              setShouldShowAddResultsSlideModal={pollsStore.setShouldShowAddResultsSlideModal}
              changePollStatus={pollsStore.changePollStatus}
              setActiveMobileTab={pollsStore.setActiveTab}
              setIsOnePollOpened={pollsStore.setIsOnePollOpened}
              isOnePollOpened={pollsStore.isOnePollOpened}
              isMobile={isMobile}
            />
          </div>
        )}
      </Draggable>
    </>
  );
};

export default observer(DraggablePollWrapper);
